module.exports = __webpack_public_path__ + "static/media/ic_recorded_filled.ed5f6260.svg";